// extracted by css-extract-rspack-plugin
export default {"narrow":"narrow-2GAEL"};